import { APIClient } from '@frontend/api-utils';

export class ModuleActuatorClient extends APIClient {
    public static readonly endpoint = '/module-api/v1';

    public static async openModule(accountId: string, spotId: string, moduleId: string, body: { iot_id?: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/open`, body);
        return await this.handleVoidResponse(response);
    }
}
